import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"20px 0"} }
const _hoisted_2 = { style: {"margin-right":"20px"} }

import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { computed, ref } from 'vue'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: ['visible'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props



const show = computed(() => {
  return props.visible
})
const wareType = ref('CN')
const ok = () => {
  emits('success', wareType.value)
  cancel()
}
const cancel = () => {
  emits('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CommonDialog, {
      visible: _unref(show),
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) ? (show).value = $event : null)),
      title: _unref(t)('请选择发货仓库'),
      onOk: ok,
      onCancel: cancel,
      footer: true,
      width: 400
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('货品仓库')), 1),
              _createVNode(_component_el_radio_group, {
                modelValue: wareType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((wareType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: "CN" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('中国仓')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: "KR" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('韩国仓')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})